export default __webpack_public_path__ + "static/media/fmlogo.86ff130e.png";